import React from "react"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Markdown from "../../components/Markdown"
import * as PropTypes from "prop-types"

const propTypes = {
  data: PropTypes.object.isRequired,
}

import style from "./index.module.css";

class Artikel extends React.Component {
  render() {
    const article = this.props.data.articleContent
    var date = article.date ? new Date(article.date) : false
    var dateString = date ? date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear() : false
    return (
      <article>
        <Helmet>
          <title>{article.title}</title>
          <meta name="description" content={article.metaDescription} />
          <meta property="og:title" content={article.title} />
          <meta property="og:description" content={article.metaDescription} />
        </Helmet>
        <div className={style.header}>
          {date &&
            <div className={style.date}>{dateString}</div>
          }
          <h1 className={style.title}>{article.title}</h1>
        </div>
        {article.subtitle &&
          <div className={style.subtitle}>{article.subtitle}</div>
        }
        {article.body &&
          <Markdown className={style.article} source={article.body.body} />
        }
        <Link className={style.back} to="/artikelen/">Terug naar alle artikelen</Link>
      </article>
    )
  }
}

Artikel.propTypes = propTypes

export default Artikel

export const pageQuery = graphql`
  query articleQuery($slug: String) {
    articleContent: contentfulArticle(slug: { eq: $slug }) {
      slug
      id
      title
      metaDescription
      subtitle
      date
      body {body}
    }
  }
`


// WEBPACK FOOTER //
// ./src/components/Artikel/index.js